import axios from "axios";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";
import { redirectTo } from "../functions/redirectTo";

/** Check if a user is already authenticated - if yes, then redirect them to the dashboard */
export const useAuthenticatedRedirect = () => {
    const { showMaxAccountSettingsPage } = useFlags();
    useEffect(() => {
        if (process.env.REACT_APP_ENV === 'localhost') {
            return;
        }
        const redirectUrl = showMaxAccountSettingsPage ? '/my/home' : '/mbp/dashboard.aspx';
        axios.get('/api/sls/session/info').then(() => {
            redirectTo(redirectUrl);
        }).catch(() => {
            // no active session - do nothing
        });
    }, [showMaxAccountSettingsPage]);
};